"use client";
import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import Image from "next/image";

export default function ThemeSwitcher({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? (
    <div
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className={` select-none p-[2px] active:scale-90 hover:opacity-80 transition-all ${className}`}
    >
      <Image
        className="cursor-pointer dark:block hidden"
        alt="theme switcher"
        height={20}
        width={20}
        sizes="20px"
        style={{ width: 'auto', height: 'auto', maxWidth: '100%' }}
        src="./images/sun-dark.svg"
      />
      <Image
        className="cursor-pointer dark:hidden"
        alt="theme switcher"
        height={20}
        width={20}
        sizes="20px"
        style={{ width: 'auto', height: 'auto', maxWidth: '100%' }}
        src="./images/sun.svg"
      />
    </div>
  ) : (
    <div
      className={` p-[2px] hover:opacity-80 transition-opacity ${className}`}
    >
      <Image
        className="cursor-pointer opacity-0"
        alt="theme switcher"
        height={20}
        width={20}
        sizes="20px"
        style={{ width: 'auto', height: 'auto', maxWidth: '100%' }}
        src="./images/sun.svg"
      />
    </div>
  );
}
